import { ScoreFactor } from "@inrange/building-manager-api-client/models-site";
import styled from "styled-components";
import {
  ScoreTooltipOrgContext,
  buildScoreTooltipText,
} from "../utils/buildScoreTooltipText";
import SiteScore from "./SiteScore";
import Tooltip from "./Tooltip";

interface SiteScoreWithInfoProps {
  siteScore?: number;
  statusColor?: string;
  scoreFactors?: ScoreFactor[];
  scoreOrgContext: ScoreTooltipOrgContext;
  tooltipPosition?:
    | "top"
    | "bottom"
    | "bottomLeft"
    | "bottomRight"
    | "left"
    | "right";
}

const SiteScoreWithInfo = ({
  siteScore,
  statusColor,
  scoreFactors,
  scoreOrgContext,
  tooltipPosition = "bottom",
}: SiteScoreWithInfoProps) => {
  const tooltipText = buildScoreTooltipText(
    siteScore,
    scoreFactors,
    scoreOrgContext
  );
  return (
    <ScoreRow>
      <SiteScore siteScore={siteScore} statusColor={statusColor} />
      {tooltipText && (
        <InfoBubble>
          <Tooltip text={tooltipText} position={tooltipPosition} maxWidth="280px" />
        </InfoBubble>
      )}
    </ScoreRow>
  );
};

const ScoreRow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const InfoBubble = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
`;

export default SiteScoreWithInfo;
